import React, { Component } from 'react';
import { connect } from 'react-redux';

import SeatsNavItem from '../../Seats/SeatsNav/SeatsNavItem/SeatsNavItem';
import HeadingH4 from '../../../UI/Headings/HeadingH4/HeadingH4';

import * as farePriceActions from '../../../../store/actions/index';
import * as seatsActions from '../../../../store/actions/index';

class SeatsNav extends Component {

    render() {

        const seatKeys = Object.keys(this.props.seats).filter((keyCode) => {
            return this.props.seats[keyCode].seatOptions[0].showSeats !== "false";
        });
        const flightDetail = this.props.seatsFlow === 'O' ? this.props.fsOneWay[0].FS : this.props.fsRoundTrip[0].FS;
        const seatMapParams = {
            TenantID: this.props.tenantID,
            departureDateTime: flightDetail[this.props.index].ddt,
            flightNumber: flightDetail[this.props.index].fl,
            resBookDesigCode: flightDetail[this.props.index].resBookDesigCode,
            depLocationCode: flightDetail[this.props.index].dac,
            arrivalLocationCode: flightDetail[this.props.index].aac,
            oac: flightDetail[this.props.index].ac,
            pid: this.props.pid,
            superPnr: this.props.superPnr,
            cabin: this.props.cabin
        }
    
        if (this.props.isSeatEmpty === null) {
            this.props.onGetSeats(seatMapParams);
        }

        return (
            <React.Fragment>
                <div className={`mb-2`}>
                    <div className="u-textUppercase">
                        <HeadingH4 size={11} weight="Medium" color="White">{this.props.type === 'depart' ? 'Depart' : 'Return'}</HeadingH4>
                    </div>
                </div>
                <nav>
                    <ul className={`u-flex`}>
                        { seatKeys.map((seat, index) => {
                            return <SeatsNavItem 
                                key={seat} 
                                active={this.props.seatsView === seat && (this.props.flow === this.props.seatsFlow) ? 'true' : 'false'}
                                onClick={() => {
                                this.props.onToggleSeatsView(seat, this.props.type, index);
                                const flightDetail = this.props.seatsFlow === 'O' ? this.props.fsOneWay[0].FS : this.props.fsRoundTrip[0].FS;
                                const seatMapParams = {
                                    TenantID: this.props.tenantID,
                                    departureDateTime: flightDetail[index].ddt,
                                    flightNumber: flightDetail[index].fl,
                                    resBookDesigCode: flightDetail[index].resBookDesigCode,
                                    depLocationCode: flightDetail[index].dac,
                                    arrivalLocationCode: flightDetail[index].aac,
                                    oac: flightDetail[index].ac,
                                    pid: this.props.pid,
                                    superPnr: this.props.superPnr,
                                    cabin: this.props.cabin
                                }
                                this.props.onGetSeats(seatMapParams);
                            }}>{seat.replace('|', ' - ')}</SeatsNavItem>
                        })} 
                    </ul>
                </nav>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        tenantID: state.farePrice.generalData.countryCodes.origin !== 'IN' || state.farePrice.generalData.countryCodes.dest !== 'IN' ? 'b2bint' : 'b2bdom',
        cabin: state.farePrice.classTypeO,
        superPnr: state.farePrice.generalData.superPnr,
        pid: state.farePrice.generalData.pricingId,
        seatsFlow: state.farePrice.seatsFlow,
        isSeatEmpty: state.seats.seats,
        fsOneWay: state.farePrice.flightScheduleOneWay,
        fsRoundTrip: state.farePrice.flightScheduleRoundTrip
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggleSeatsView: (view, tripType, index) => dispatch(farePriceActions.toggleSeatsView(view, tripType, index)),
        onGetSeats: (seatParams) => dispatch(seatsActions.getSeats(seatParams))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatsNav);


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/SeatsNav/SeatsNav.js